(() => {
  'use strict';
  const desktop = matchMedia('(hover: hover) and (pointer: fine)');
  const registered = new WeakSet();
  const loading = new WeakSet();
  async function prepare(anchor) {
    if (!desktop.matches || !anchor || loading.has(anchor) || anchor.hasAttribute('data-secondary-ready')) return;
    const image = anchor.querySelector('[data-secondary-image]');
    if (!image) return;
    loading.add(anchor);
    image.loading = 'eager';
    image.sizes = image.dataset.sizes;
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    try {
      await image.decode();
      if (image.naturalWidth > 0) anchor.setAttribute('data-secondary-ready', '');
    } catch (_) { /* Keep the main photo on any failed second-image request. */ }
    finally { loading.delete(anchor); }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && desktop.matches) { prepare(entry.target); observer.unobserve(entry.target); }
    });
  }, {rootMargin:'200px'}) : null;
  function scan(root) {
    if (!desktop.matches || !root.querySelectorAll) return;
    const anchors = root.matches?.('[data-card-image-swap]') ? [root] : [...root.querySelectorAll('[data-card-image-swap]')];
    anchors.forEach(anchor => {
      if (!anchor.querySelector('[data-secondary-image]') || registered.has(anchor)) return;
      registered.add(anchor); observer?.observe(anchor);
    });
  }
  function init() {
    scan(document);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); }))).observe(document.body, {childList:true,subtree:true});
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const zone = event.target.closest('[data-image-hover-zone]');
    if (zone) prepare(zone.querySelector('[data-card-image-swap]'));
  });
  document.addEventListener('focusin', event => prepare(event.target.closest('[data-card-image-swap]')));
  desktop.addEventListener('change', () => { if (desktop.matches) scan(document); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
